module.exports = __webpack_public_path__ + "static/media/答疑二@2x.4556ec90.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/答疑二@2x.png
// module id = 1596
// module chunks = 0